import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { filter, map, Observable } from 'rxjs';
import { PhAuthService } from '../common/ph-auth';

@Injectable()
export class GraphQlGuard implements CanActivate {
  constructor(private phAuthSrv: PhAuthService) {}

  canActivate(): Observable<boolean> {
    return this.phAuthSrv.token$.pipe(filter((token) => !!token), map(() => true));
  }
}
